/**
 * Default competition names for a brand-new organization. ONE source for the
 * API bootstrap (organization.controller.ts) and the create wizard's inline
 * structure panel (INT-0039), so what the organizer previews is exactly what
 * the server would have named.
 */
export type Hemisphere = 'north' | 'south';

/** "Spring 2027": the NEXT season from `now`, year rolling over after Autumn. */
export function nextSeasonName(hemisphere: Hemisphere = 'north', now: Date = new Date()): string {
  const seasonList = hemisphere === 'north'
    ? ['Winter', 'Spring', 'Summer', 'Autumn']
    : ['Summer', 'Autumn', 'Winter', 'Spring'];
  const currentSeasonIndex = Math.floor((now.getMonth() / 12) * 4) % 4;
  const nextSeasonIndex = (currentSeasonIndex + 1) % 4;
  // Wrapping from Autumn (index 3) to Winter (index 0) crosses the year.
  const year = nextSeasonIndex === 0 ? now.getFullYear() + 1 : now.getFullYear();
  return `${seasonList[nextSeasonIndex]} ${year}`;
}

/** The bootstrap's competition name: "<Season YYYY> Tournament" or "<Season YYYY>". */
export function bootstrapCompetitionName(contestType: 'tournament' | 'season', now: Date = new Date()): string {
  const season = nextSeasonName('north', now);
  return contestType === 'tournament' ? `${season} Tournament` : season;
}
